import { PublicPage } from 'api/website';

type Props = {
  content: PublicPage;
};

export function getLastNonScollTrackingContentBlock({ content }: Props) {
  let lastBlock;
  let i = content.contentBlocks.length;

  const setLastBlock = () => {
    lastBlock =
      content.contentBlocks && content.contentBlocks.length
        ? content.contentBlocks[i]
        : null;
  };

  setLastBlock();

  while (lastBlock && lastBlock.type === 'SCROLL_TRACKING') {
    i -= 1;
    setLastBlock();
  }

  return lastBlock;
}
